<template>

  <v-container fluid>
    <v-row>
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>Вызовы</v-card-title>

          <v-form ref="form">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <DateTimePicker v-model="date" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <ProjectSelector v-model="projects" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <custom-select
                    label="Статусы звонков"
                    v-model="statuses"
                    :items="call_statuses"
                    itemText="label"
                    chipText="label"
                    itemValue="value"
                    multiple
                  />
                </v-col>

                <v-col
                  v-if="currentUser.role.name !=='operator_customer'"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                >
                  <custom-select
                    label="Доп. параметры"
                    v-model="extra"
                    :items="extraOptions"
                    multiple
                  />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-row class="mt-0 pl-3">
                    <span>Продолжительность (сек.)</span>
                  </v-row>
                  <v-row>
                  <!-- <div class="col-6"> -->
                    <v-col cols="6">
                      <v-text-field
                        v-model="duration.from"
                        hide-details
                        single-line
                        prefix="От"
                        type="number"
                      />
                    </v-col>
                  <!-- </div> -->

                  <!-- <div class="col-6"> -->
                    <v-col cols="6">
                      <v-text-field
                        v-model="duration.to"
                        hide-details
                        single-line
                        prefix="До"
                        type="number"
                      />
                    </v-col>
                  <!-- </div> -->
                  </v-row>
                </v-col>

                <v-col cols="12" sm="12" md="4" lg="12" align="right" class="mt-auto">
                  <v-btn color="success" id="rep_btn" @click="loadReport">Поиск</v-btn>
                </v-col>
              </v-row>
            </v-card-text>

          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mt-5">
      <!-- Пагинация над таблицей -->
      <v-row v-if="report.items.length > 0">
        <v-col cols="3">
          <v-pagination
            v-model="meta.current_page"
            :total-visible="paginationTotalVisible"
            :length="meta.last_page"
            @input="pageChange"
          />
        </v-col>
      </v-row>

      <v-data-table
          :headers="report.headers"
          :items="report.items"
          :items-per-page="report.items.length"
          :loading="loading"
          item-key="uid"
          loading-text="Загрузка..."
          no-data-text="Ничего не найдено"
          hide-default-footer
          :expanded.sync="expanded"
          :item-class= "rowColor"
      >
        <!-- Раскрывашка -->
        <template #[`expanded-item`]="{ item, headers }">
          <td v-if="item.complaint !== null" :colspan="headers.length" class="py-5 px-12">

            <h4>Отзыв №{{ item.complaint.id }}</h4>

            <table>
              <tbody>
                <tr>
                  <td>Заказчик:</td>
                  <td>{{ item.complaint.project }}</td>
                </tr>
                <tr>
                  <td>Тип отзыва:</td>
                  <td>{{ item.complaint.type }}</td>
                </tr>
                <tr>
                  <td>КЛН:</td>
                  <td>{{ item.complaint.kln }}</td>
                </tr>
                <tr>
                  <td>Критерии:</td>
                  <td>{{ item.complaint.creterials }}</td>
                </tr>
                <tr>
                  <td>Комментарий:</td>
                  <td>{{ item.complaint.comment }}</td>
                </tr>
                <tr>
                  <td>Автор:</td>
                  <td>{{ item.complaint.created_by }}</td>
                </tr>
                <tr>
                  <td>Дата:</td>
                  <td>{{ item.complaint.created_at }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </template>

        <!-- Дата -->
        <template #[`item.date`]="{ item }">
          {{ utils.formattingStringWithTime(item.date) }}
        </template>

        <!-- Анализ -->
        <template #[`item.voicer[status]`]="{ item }">
          <v-icon v-if="item.voicer">mdi-comment-text-multiple</v-icon>
        </template>

        <!-- Маркеры абонентов -->
        <template #[`item.voicer[markers][1][dictionary_name]`]="{ item }">
          <p v-if="item.voicer">
             <span v-for="(item1, index) in item.voicer['markers']" v-bind:key="index">
               <span v-if="item1.for==2">
                 <v-chip label :color="item1.color">
                   {{ item1.dictionary_name }} X {{ item1.words.length }}
                 </v-chip>
               </span>
             </span>
          </p>
        </template>

        <!-- Маркеры операторов -->
        <template #[`item.voicer[markers][0][dictionary_name]`]="{ item }">
          <p v-if="item.voicer">
             <span v-for="(item1, index) in item.voicer['markers']" v-bind:key="index">
               <span v-if="item1.for!==2">
                 <v-chip label :color="item1.color">
                   {{ item1.dictionary_name }} X {{ item1.words.length }}
                 </v-chip>
               </span>
             </span>
          </p>
        </template>

        <!-- Статус -->
        <template #[`item.status`]="{ item }">
          <v-tooltip bottom v-if="item.status">
            <template v-slot:activator="{ on }">
              <span v-on="on"><!-- то что показано изначально-->
                <v-icon dense align="left" v-if="item.status === 'Завершен агентом'">mdi-account-remove</v-icon>
                <v-icon small align="right" v-if="item.status === 'Завершен агентом'">mdi-account-outline</v-icon>

                <v-icon dense align="left" v-if="item.status === 'Завершен клиентом'">mdi-account-outline</v-icon>
                <v-icon small align="right" v-if="item.status === 'Завершен клиентом'">mdi-account-remove</v-icon>
              </span>
            </template>
            <span>   <!-- сама всплывающая подсказка -->
              <span style="color: #ffffff" v-if="item.transfer"> Переведен на: {{ item.transfer }}</span>
              <!-- uid стоит чтоб было видно что оно работает, там потом нужен transfer -->
              <br v-if="item.transfer">
              <span style="color: #ffffff" v-if="item.status === 'Завершен клиентом'">Завершен клиентом</span>
              <span style="color: #ffffff" v-if="item.status === 'Завершен агентом'">Завершен агентом</span>
            </span>
          </v-tooltip>
          <span v-else>{{ item }}</span>
        </template>

        <!-- КЛН -->
        <template #[`item.kln`]="{ item }">
          <v-chip
              v-if="item.kln"
              small
              color="success"
              dark
              @click="changeExpand(item)"
          >
            {{ item.kln }}
          </v-chip>
        </template>

        <!-- Проверен -->
        <template #[`item.meta`]="{ item }">
          <v-icon v-if="item.meta">mdi-check</v-icon>
        </template>

        <!-- Сброшен -->
        <template #[`item.has_dropped`]="{ item }">
          <span v-if="item.has_dropped">Да</span>
          <span v-else>Нет</span>
        </template>

        <!-- Просмотр -->
        <template #[`item.actions`]="{ item }">
          <v-btn icon @click="viewItem(item)">
            <v-icon dense>mdi-eye</v-icon>
          </v-btn>
          <v-btn icon :href="`http://statix.oline/calls/${item.uid}`" target="_blank">
            <v-icon dense>mdi-dock-window</v-icon>
          </v-btn>
        </template>

      </v-data-table>

      <!-- Пагинация под таблицей -->
      <v-row
        v-if="perPage >= 25 && report.items.length > 0"
        class="ml-10 mt-2"
      >
        <v-col cols="3">
          <v-pagination
            v-model="meta.current_page"
            :total-visible="paginationTotalVisible"
            :length="meta.last_page"
            @input="pageChange"
          />
        </v-col>
      </v-row>
    </v-card>

    <!-- Просмотр звонка модалка -->
    <dialog-view
      v-if="dialogView"
      v-model="dialogView"
      fullscreen
      title="Просмотр информации о вызове"
    >
      <call-info :uid="dialogViewUid" />
    </dialog-view>
  </v-container>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from 'moment'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';

export default {
  name: "SpeechAnalysisReportCustomer",
  props: ['username'],
  components: { ProjectSelector },
  data() {
    return {
      expanded: [],
      query: {},
      wiretapping_rate: '',
      date: {},
      duration: {
        from: 0,
        to: 7200,
      },
      projects: [],
      dictionaries: [],
      call_statuses: [],
      statuses: [],
      dictionaries_excluded: [],
      agents: [],
      report: {
        headers: [
          {
            sortable: false
          },
          {
            text: "Дата",
            value: "date",
            sortable: false,
            caption: '"Да": Если % прослушки оператора ниже целевого  процента прослушки по проекту или КЛН оператора ниже 90%.',
          },
          {
            text: "Оператор",
            value: "agent",
            sortable: false,
          },
          {
            text: "Очередь",
            value: "queue",
            sortable: false,
          },
          {
            text: "Абонент",
            value: "client",
            sortable: false,
          },
          {
            text: "Анализ",
            //  value: "client",
            value: "voicer[status]",
            sortable: false,
          },
          {
            text: "Маркеры абонентов",
            //value: "client",
            value: "voicer[markers][1][dictionary_name]",
            sortable: false,
          },
          {
            text: 'Маркеры операторов',
            //value: "client",
            value: "voicer[markers][0][dictionary_name]",
            sortable: false,
          },
          {
            text: 'Статус',
            //width: 100, работает
            value: 'status',
            sortable: false,
          },
          {
            text: 'Ожидание',
            value: 'wait',
            sortable: false,
          },
          {
            text: 'Длит.',
            value: 'duration',
            sortable: false,
          },
          // { нет данных
          //   text: 'Max Hold',
          //   value: 'max_hold',
          // },
          // {
          //   text: 'Перевод',
          //   value: 'transfer',
          //   sortable: false,
          // },
          {
            text: 'Клн',
            value: 'kln',
            sortable: false,
          },
          {
            text: 'Проверен',
            value: 'meta',
            sortable: false,
          },
          {
            text: 'Сброшен',
            value: 'has_dropped',
            sortable: false,
          },
          {
            text: 'Просмотр',
            value: 'actions',
            sortable: false
          },
        ],
        items: [],
        projectInfo: {},
        projectWiretapIsNeeded: false,
      },
      perPage: 25,
      perPages: [5, 10, 20, 25, 50, 100],
      page: 1,
      paginationTotalVisible: 7,
      orderBy: 'date',
      orderDesc: true,
      dialogView: false,
      dialogViewUid: null,

      extraOptions: [
        {name: 'Только распознанные', id: 'only_recognized'},
        {name: 'Есть КЛН', id: 'only_kln'},
        {name: 'Только сброшенные', id: 'only_dropped'},
        {name: 'Завершен по нажатию кнопки', id: 'exit_with_key'},
      ],

      extra: [],
    }
  },

  computed: {
    ...mapGetters({
      hasPermission: "user/hasPermission",
      // projectsGetter: "projects/projects",
      dictionariesGetter: "projects/dictionaries",
      // agentsGetter: "projects/agents",
      queuesGetter: "projects/queues",
      filteredQueues: "projects/filteredQueues",
      loading: "shared/getLoading",
      meta: "shared/meta",
      currentUser: 'user/currentUser',
    }),

    payload() {
      return {
        period: [
          moment(this.date.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.date.end).format('YYYY-MM-DD HH:mm:ss'),
        ],

        duration_range: [
          this.duration.from,
          this.duration.to,
        ],

        projects: this.projects,
        page: this.page,
        limit: this.perPage,

        users: this.agents,
        dictionaries: this.dictionaries,
        exclude_dictionaries: this.dictionaries_excluded,

        only_recognized: this.extra.includes('only_recognized') ? '1' : '0',
        only_kln: this.extra.includes('only_kln') ? '1' : '0',
        only_dropped: this.extra.includes('only_dropped') ? '1' : '0',
        exit_with_key: this.extra.includes('exit_with_key') ? '1' : '0',
        
        statuses: this.statuses,
      }
    },

    wiretappingRateTitle() {
      if (this.report.wiretapping_rate !== '') {
        return 'Целевой показатель количества прослушанных звонков к их общему количеству';
      }

      return 'Целевой показатель количества прослушанных звонков к их общему количеству.\n'
          + 'Если прогнозное количество/количество звонков за месяц:\n'
          + '- до 100 звонков за месяц - 30%\n'
          + '- от 101 до 300 звонков - 15%,\n'
          + '- от 301 до 500 зв. - 10%,\n'
          + '- от 501 до 7500 зв. - 5%,\n'
          + '- от 7501 зв. и более - 3%.\n'
          + '- от 15001 зв. и более - 1.5%';
    },

    callsCountTitle() {
      if (this.report.month === 'previous') {
        return 'Всего звонков';
      }

      return 'Кол-во принятых звонков за 28 дней на текущую дату. / 28 дней * 30.42 (среднее количество дней в месяце)';
    },

    rabbitIconTitle() {
      return 'Оператор заслуживающий доверия т.к. выполнены все следующие условия:\n'
          + 'а) % прослушки за выбранный  месяц более 3%\n'
          + 'б) кол-во прослушанных звонков за выбранный месяц более 3 шт.\n'
          + 'в) у оператора за последний месяц КЛН выше 97%\n'
          + 'г) у оператора за 3 последних месяца (в том числе текущем) КЛН выше 97%';
    },
  },

  watch: {
    search() {
      if (this.search.length > 3) {
        this.refreshTable()
      } else if (this.search.length === 0) {
        this.refreshTable()
      }
    },

    call(newVal) {
      if (newVal !== null) {
        this.dialogView = true;
      } else {
        this.dialogView = false;
      }
    },

    perPage() {
      this.page = 1
      this.refreshTable()
    },
  },

  methods: {
    ...mapActions({
      // loadProjects: 'projects/loadProjects',
      // loadAgents: 'projects/loadAgents',
      loadDictionaries: 'projects/loadDictionaries',
      loadCalls: 'reports_speech_analysis/loadCalls',
      loadCallStatuses: 'reports_speech_analysis/loadCallStatuses',
      resetAllState: 'resetAllState',
    }),

    viewItem(call) {
      this.dialogViewUid = call.uid;
      this.dialogView = true;
      //this.loadCall({uid: call.uid, query: {with: 'transcribe,audios,markers'}});
      // this.loadCall({uid: call.uid, query: {with: 'transcribe,audios,markers'}}).then((call) => {
      //     this.call = call
      //     this.dialogView = true
      // });
    },

    // setDictionariesToNorm(dictionaries) {
    //   if (dictionaries.length){
    //
    //   }
    // },
    pageChange(page) {
      this.page = page
      this.refreshTable()
    },

    // tableAnalisys(page) {
    //   this.page = page
    //   this.refreshTable()
    // },
    refreshTable() {
      //  if (this.$refs.form.validate()) {
      this.loadCalls(this.payload).then((resp) => {
        this.report.payload = this.payload;
        this.report.payload.phrase = this.searchPhrase;
        this.report.payload.phraseOwner = this.phraseOwner;
        this.report.items = resp
      });
      //   }
    },

    changeExpand(curItem) {
      const itemIndex = this.expanded.findIndex(item => item.uid === curItem.uid);

      if (itemIndex === -1) {
        this.expanded.push(curItem);
        return;
      }

      this.expanded.splice(itemIndex, 1);
    },

    async loadReport() {
      if (this.$refs.form.validate()) {
        this.page = 1;
        await this.loadCalls(this.payload)
            .then(response => {
              this.report.items = response;
            });
      }
    },

    rowColor(item) {
      return item.is_current_viewed ? 'viewed-call' : '';
    },
  },

  async mounted() {
    if (this.$route.query['period[start]'] && this.$route.query['period[end]']) {
      this.date.start = new Date(this.$route.query['period[start]']);
      this.date.end = new Date(this.$route.query['period[end]']);
    }
    // await this.loadAgents();
    // this.loadProjects({with: 'tags'});
    this.loadDictionaries();
    
    this.call_statuses = await this.loadCallStatuses();
    if (this.$route.query.call_status) {
      this.statuses.push(this.$route.query.call_status);
    } else {
      this.call_statuses.forEach(s => {
        if (s.checked) this.statuses.push(s.value);
      })
    }



    if (this.$route.query.user_id) {
      this.agents = [parseInt(this.$route.query.user_id)];
    }

    if (this.$route.query.project) {
      this.projects = [Number(this.$route.query.project)];
      this.loadReport();
    }
  },

  beforeDestroy() {
    this.resetAllState();
  },
}


</script>

<style lang="scss">

.theme--light {
  .viewed-call {
    background-color: #c8e6c8 !important;
  }
}

.theme--dark {
  .viewed-call {
    background-color: #546E7A !important;
  }
}
</style>
